import { selectors as personsSelectors } from 'store/modules/persons'
import { selectors as userSessionSelectors } from 'store/modules/user-session'

import { PersonWithAddress } from './types'

export const getFamilyMembersWithAddress = (state: any): PersonWithAddress[] => {
  const employee = personsSelectors.getPersonSelector(state)
  const dependents = personsSelectors.getDependents(state)

  return [employee, ...dependents].filter(
    (person): person is PersonWithAddress =>
      person &&
      !!person.Id &&
      !!person.PostalCode &&
      !!person.StateProvince &&
      !!person.County
  )
}

export const getEnrollmentYear = (state: any): number => {
  const enrollment = userSessionSelectors.getEnrollmentSession(state)
  return enrollment?.BenefitEffectiveDate
    ? new Date(enrollment.BenefitEffectiveDate).getFullYear()
    : new Date().getFullYear() + 1
}

export const getRatingAreaRecalculationProps = (state: any) => ({
  familyMembers: getFamilyMembersWithAddress(state),
  enrollmentYear: getEnrollmentYear(state),
  employeePublicKey: userSessionSelectors.getUserId(state),
  enrollmentPublicKey: userSessionSelectors.getEnrollmentPublicKey(state),
})
